import cls from "classnames";
import { map } from "lodash";
import { Carousel } from "antd";
import { useSize } from "ahooks";
import React, { useEffect, useRef } from "react";
import { useSignal } from "@preact/signals-react";
import styles from "./SwitchBar.module.scss";
export var SwitchBarPosition = /*#__PURE__*/function (SwitchBarPosition) {
  SwitchBarPosition[SwitchBarPosition["top"] = 0] = "top";
  SwitchBarPosition[SwitchBarPosition["bottom"] = 1] = "bottom";
  return SwitchBarPosition;
}({});
export function SwitchBar(props) {
  var _props$position;
  // 唯一id 好区分是哪个switchBar
  var randomId = useSignal(Math.random().toString().slice(2));
  var sliderRef = useRef(null);
  var active = useSignal(0);
  var currentSlideRef = useSignal(null);
  var position = (_props$position = props.position) !== null && _props$position !== void 0 ? _props$position : SwitchBarPosition.top;
  var activeCls = function activeCls(index) {
    return cls(styles.item, index === active.value && styles.active);
  };
  var size = useSize(currentSlideRef.value);
  var handleClick = function handleClick(index) {
    var _sliderRef$current;
    active.value = index;
    (_sliderRef$current = sliderRef.current) === null || _sliderRef$current === void 0 || _sliderRef$current.goTo(index);
  };
  var handleBeforeChange = function handleBeforeChange(from, to) {
    var currentSlide = document.querySelector(".switch-bar-".concat(randomId.value, " .slick-slide[data-index=\"").concat(to, "\"]"));

    // 更新currentRef => useSize重新计算height
    currentSlideRef.value = currentSlide;
  };
  var CirclePointView = function CirclePointView() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.switchBarWrapper,
      key: "circlePointView"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.switchBar
    }, map(new Array(props.sliderCount).fill(""), function (_, index) {
      return /*#__PURE__*/React.createElement("div", {
        className: activeCls(index),
        key: index,
        onClick: function onClick() {
          return handleClick(index);
        }
      });
    })));
  };
  var ContentView = function ContentView() {
    var _size$height;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        height: (_size$height = size === null || size === void 0 ? void 0 : size.height) !== null && _size$height !== void 0 ? _size$height : "auto",
        overflow: "hidden"
      },
      className: "switch-bar-".concat(randomId.value),
      key: "contentWrapper"
    }, /*#__PURE__*/React.createElement(Carousel, {
      ref: sliderRef,
      dots: false,
      key: "contentView",
      beforeChange: handleBeforeChange
    }, props.children));
  };
  var list = position === SwitchBarPosition.top ? [CirclePointView(), ContentView()] : [ContentView(), CirclePointView()];
  useEffect(function () {
    handleBeforeChange(0, 0);
  }, [props.children]);
  return /*#__PURE__*/React.createElement("div", null, list);
}